/* eslint-disable implicit-arrow-linebreak */
import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../views/HomePage.vue';
import AddToCalendar from '../views/AddToCalendar.vue';
import ThanksPage from '../views/ThanksPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'LayoutUnSlug',
    component: () => import(/* webpackChunkName: "unslug" */ '../layouts/UnSlug.vue'),
  },
  {
    path: '/:slug',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/:slug/addToCalendar',
    name: 'AddTocalendar',
    component: AddToCalendar,
  },
  {
    path: '/:slug/registraion-confirmation',
    name: 'thanks',
    component: ThanksPage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
